import axios from "axios";
import { saveAs } from "file-saver";
import { ActionTypes } from "../../reducers/routesStatus/types";

import { PROYECT, api_get, api_post, api_put } from "services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "../search/searchActions";
import { formatCustomDate } from "helpers/dateTools";
import { addLabelArray } from "helpers/addLabelArray";
import { printFillingOrderTicket } from "../fillingOrder/fillingOrderActions";
import { addPrintQueue } from "../printers/printersActions";
import { ActionTypes as LiquidationActionTypes } from "redux/reducers/liquidations/types";
import { liquidationStatus } from "helpers/dictionary";
import { persistLocalStorage } from "helpers/localstorageTool";
import { getErrorBlob } from "helpers/extractError";

const { SET_SGC_TO_LIQUIDATION } = LiquidationActionTypes;

const {
  FILTER_ROUTES_INPUTS,
  FILTER_ROUTES,
  GET_DATA,
  SET_ERROR,
  CHANGE_STATION_ROUTES,
  CHANGE_UNIT_TYPE,
  CHANGE_START_DATE,
  CHANGE_END_DATE,
  CLEAR_ERROR,
  SET_ROUTE,
  SET_CONFIG_PAGE,
  SET_CONFIG_PAGE_SIZE,
  SET_CONFIG_FILTER,
  SET_ROUTES_SNACKBAR,
  RESET_ROUTES_SNACKBAR,
  SET_ENDOWMENTS,
  REQUEST_ENDOWMENTS,
  EDIT_ENDOWMENT,
  SET_SETTLEMENT,
  RESET_SETTLEMENT,
  SELECT_NOTE,
  DESELECT_NOTE,
  REMOVE_SETTLEMENT_NOTE,
  REQUEST_CUSTOMER,
  SET_CUSTOMER_ROUTE,
  REQUEST_SETTLEMENT_NOTE,
  EDIT_SETTLEMENT_NOTE,
  SET_NOTES_MODAL,
  GET_ENDOWMENT,
  SET_TICKET_TO_PRINT,
  SET_CONFIG_SORTED,
  SET_ROUTES_INPUTS,
  GET_SETTLEMENT_DISPENSERS,
  GET_SETTLEMENT_PRODUCTS,
  GET_SETTLEMENT_PAYMENTS,
  GET_SETTLEMENT_ACCOUNT_DETAILS,
  SET_SETTLEMENT_NEW_NOTE,
  ADD_SETTLEMENT_NEW_NOTE,
  CHANGE_SETTLEMENT_DISPENSER,
  CHANGE_SETTLEMENT_START_ROUTE_ENDOWMENTS,
  CHANGE_SETTLEMENT_END_ROUTE_ENDOWMENTS,
  CHANGE_SETTLEMENT_LTS,
  CHANGE_SETTLEMENT_PERCENTAGE,
  SET_KG_BULK_VALUE,
  SET_SETTLEMENT_NEW_NOTE_DETAIL,
  SELECT_SETTLEMENT_NEW_NOTE_DETAIL,
  EDIT_SETTLEMENT_NEW_NOTE_DETAIL,
  DELETE_SETTLEMENT_NEW_NOTE_DETAIL,
  ASSIGN_SGC,
  CLEAN_ROUTES_BY_TYPE,
  SETTLEMENT_TOTAL_REPORT,
  SET_PIN,
  SET_AUTO_MODE,
  SET_CAUSES,
  SET_DEL_CAUSE,
  IS_NEW_NOTE,
  REMOVE_ALL_NOTES,
  REMOVE_ROUTE_SHARE,
  UPDATE_NOTE_FOLIO,
  SET_TRANSFER_INVOICE_TOKEN,
} = ActionTypes;

export const routesStatusInput = (key, value) => {
  return {
    type: FILTER_ROUTES_INPUTS,
    payload: { key, value },
  };
};
export const filtersRoutes = (timing) => {
  const upper = timing.toUpperCase();
  return { type: FILTER_ROUTES, payload: upper };
};

export const cleanRoutesByType = () => {
  return {
    type: CLEAN_ROUTES_BY_TYPE,
  };
};

export const changeStationRoutes = (station) => {
  return {
    type: CHANGE_STATION_ROUTES,
    payload: station,
  };
};

export const changeUnitType = (type) => {
  return {
    type: CHANGE_UNIT_TYPE,
    payload: type,
  };
};

export const changeStartDate = (date) => {
  return {
    type: CHANGE_START_DATE,
    payload: date,
  };
};

export const changeEndDate = (date) => {
  return {
    type: CHANGE_END_DATE,
    payload: date,
  };
};

export const setError = (error) => {
  return {
    type: SET_ERROR,
    payload: error,
  };
};

export const clearError = () => {
  return {
    type: CLEAR_ERROR,
  };
};

export const setRoute = (route) => {
  return {
    type: SET_ROUTE,
    payload: route,
  };
};

export const setConfigPage = (key, page) => {
  return {
    type: SET_CONFIG_PAGE,
    payload: { key, value: page },
  };
};

export const setConfigPageSize = (key, pageSize) => {
  return {
    type: SET_CONFIG_PAGE_SIZE,
    payload: { key, value: pageSize },
  };
};

export const setConfigFilter = (key, filter) => {
  return {
    type: SET_CONFIG_FILTER,
    payload: { key, value: filter },
  };
};

export const setConfigSorted = (key, sort) => {
  return {
    type: SET_CONFIG_SORTED,
    payload: { key, value: sort },
  };
};

export const getRoutes = (payload, unitsCallback = null) => {
  const { station: stationId, start, end, type } = payload;
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/routes?`;
  // let queryParams = `idStation=7249c09c-55fd-4ef1-8ba4-bdfced4ed385&start=2025-01-02&end=2025-01-02&type=ESTACIONARIO`;
  let queryParams = `idStation=${stationId}&start=${start}&end=${end}&type=${type}`;
  const url = `${baseUrl}${queryParams}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingRoutes"));
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: GET_DATA,
          payload: resp,
        });
        // Cargar la configuración de unidades de la planta
        stationId && unitsCallback && dispatch(unitsCallback(stationId));
        dispatch(stopRequestComp("loadingRoutes"));
      })
      .catch((error) => {
        dispatch(setSnackbar(error?.message ? error.message : "Error"));
        dispatch(stopRequestComp("loadingRoutes"));
      });
  };
};

export const getSettlementProducts = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/products`;
  return async (dispatch) => {
    // dispatch(startRequestComp("loadingSettlement"));
    await api_get(url)
      .then((resp) => {
        if (resp.length === 0)
          dispatch(setSnackbar("No se encontraron tipos de productos"));
        const nResponse = addLabelArray(resp, "name");
        dispatch({
          type: GET_SETTLEMENT_PRODUCTS,
          payload: nResponse,
        });

        // dispatch(stopRequestComp("loadingSettlement"));
      })
      .catch((err) => {
        // dispatch(stopRequestComp("loadingSettlement"));
        dispatch(setSnackbar(err));
      });
  };
};

export const getSettlementUnitDispensers = (idUnit) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/${idUnit}/dispensers`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingSettlement"));
    await api_get(url)
      .then((resp) => {
        if (resp.length === 0)
          dispatch(setSnackbar("No se encontraron dispensadores"));
        dispatch({
          type: GET_SETTLEMENT_DISPENSERS,
          payload: resp.map((dispenser) => ({
            ...dispenser,
            value: dispenser.id,
            label: `${dispenser.name}-${dispenser.consecutive}`,
          })),
        });
        dispatch(stopRequestComp("loadingSettlement"));
      })
      .catch((err) => {
        const error = err ? err : "Error en el servicio";
        dispatch(stopRequestComp("loadingSettlement"));
        dispatch(setSnackbar(error));
      });
  };
};

export const getSettlementPaymentTypes = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/payments`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingPayments"));
    await api_get(url)
      .then((resp) => {
        if (resp.length === 0)
          dispatch(setSnackbar("No se encontraron tipos de pago"));
        dispatch({
          type: GET_SETTLEMENT_PAYMENTS,
          payload: resp.map((payment) => ({
            ...payment,
            value: payment.id,
            label: payment.name,
            type: payment.method,
          })),
        });
      })
      .catch((error) =>
        dispatch(
          setSnackbar(error ? error : "Error contacte al administrador"),
        ),
      );
    dispatch(stopRequestComp("loadingPayments"));
  };
};

export const getSettlement = (
  values,
  startRoute,
  endRoute,
  hist = null,
  isStationary = false,
  idDispenser,
) => {
  const { route: idUnit, unitCapacity } = values;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/settlements/units/${idUnit}/routes?idStart=${startRoute}&idEnd=${endRoute}`;
  const urlD = `${process.env.REACT_APP_URL}${PROYECT}/settlements/units/${idUnit}/dispensers/${idDispenser}/routes?idStart=${startRoute}&idEnd=${endRoute}`;

  const mainUrl = isStationary ? urlD : url;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingSettlement"));
    await dispatch(getSettlementPaymentTypes());
    await api_get(mainUrl)
      .then((resp) => {
        const settlement = {
          ...resp,
          idUnit: idUnit,
          settlementStatus: resp.settlementStatus
            ? resp.settlementStatus
            : liquidationStatus.value.ON_HOLD,
          routes: {
            ...resp.routes,
            end: {
              ...resp.routes.end,
            },
          },
          unit: {
            ...resp.unit,
            unitCapacity: unitCapacity,
          },
        };
        dispatch({ type: SET_SETTLEMENT, payload: settlement });
        hist && hist.push(`/admin/rutas-liquidaciones/${idUnit}`);
      })
      .catch((err) => {
        const error = err.message ? err.message : err;
        dispatch(setSnackbar(error));
      });
    dispatch(stopRequestComp("loadingSettlement"));
  };
};

export const getLiquidation = (id, hist = null, date, fillingOrder) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/settlements/${id}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingSettlement"));
    // await dispatch(getSettlementPaymentTypes())
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: SET_SETTLEMENT,
          payload: { ...resp, date, fillingOrder: fillingOrder },
        });
        dispatch(stopRequestComp("loadingSettlement"));
        hist && hist.push(`/admin/rutas-liquidaciones/${id}`);
      })
      .catch((err) => {
        dispatch(stopRequestComp("loadingSettlement"));
        dispatch(
          setSnackbar(
            err ||
              err?.message ||
              err.message.error ||
              "Error. Contacte a soporte",
          ),
        );
      });
  };
};

export const removeSettlementNote = (noteId, causeId) => {
  return {
    type: REMOVE_SETTLEMENT_NOTE,
    payload: { noteId, causeId },
  };
};
export const selectNote = (id) => {
  return {
    type: SELECT_NOTE,
    payload: id,
  };
};

export const deselectNote = () => {
  return {
    type: DESELECT_NOTE,
  };
};

export const cleanSettlement = () => {
  return { type: RESET_SETTLEMENT };
};

export const editSettlementNote = (id, body, close = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/settlements/notes/${id}`;
  return async (dispatch) => {
    dispatch({ type: REQUEST_SETTLEMENT_NOTE });
    await api_put(url, body)
      .then((resp) => {
        dispatch({ type: EDIT_SETTLEMENT_NOTE, payload: resp });
        dispatch(setSnackbar("Nota editada", "success"));
        close && close();
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
  };
};

export const saveSettlement = (body, type, hist = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/settlements/${
    type === "ESTACION" ? "dispensers" : ""
  }`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingSettlement"));

    await api_post(url, body)
      .then(async (resp) => {
        dispatch({
          type: SET_ENDOWMENTS,
          payload: { ...resp, services: body?.services },
        });
        dispatch({ type: SET_TICKET_TO_PRINT, payload: resp.urlTicket });
        dispatch(
          setRoutesSnackbar({
            message: "Liquidación guardada con éxito",
            color: "success",
          }),
        );
        persistLocalStorage("route-share", {
          isSharing: true,
          route: body.idUnit,
        });
        if (type !== "ESTACION" && resp.status !== "SAVED") {
          resp.urlTicket.length > 0 &&
            dispatch(
              addPrintQueue({
                url: resp.urlTicket,
                fileName: `${body.unit.number}-Liquidación`,
              }),
            );
          body.sgc &&
            dispatch(
              assignSGC({ ...body, folio: resp.folio }, { id: resp.id }, hist),
            );
        }
        resp.status !== "SAVED" &&
          type === "ESTACION" &&
          dispatch(
            addPrintQueue({
              url: resp.urlTicket,
              fileName: `${body.unit.number}-Liquidación`,
            }),
          );
        dispatch(stopRequestComp("loadingSettlement"));
        hist && hist();
      })
      .catch((err) => {
        dispatch(
          setSnackbar(
            err?.message ? err.message : err || "Error en la petición...",
          ),
        );
        dispatch(stopRequestComp("loadingSettlement"));
      });
  };
};

export const getCustomer = (id) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}`;
  return async (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER });
    await api_get(url)
      .then((resp) => {
        dispatch({ type: SET_CUSTOMER_ROUTE, payload: resp[0] });
      })
      .catch((err) => {
        dispatch(
          setRoutesSnackbar({
            message: err,
            color: "danger",
          }),
        );
      });
  };
};

export const getEndowments = (type, idStation) => {
  const newType = type === "PORTATIL" ? "mobile" : "stationary";
  const url = `${process.env.REACT_APP_URL}${PROYECT}/endowments/${newType}?stations=${idStation}`;
  return async (dispatch) => {
    dispatch({ type: REQUEST_ENDOWMENTS });
    await api_get(url)
      .then((resp) => {
        dispatch({ type: SET_ENDOWMENTS, payload: resp });
      })
      .catch((err) => {
        dispatch(
          setRoutesSnackbar({
            message: err,
            color: "danger",
          }),
        );
      });
  };
};

export const getEndowment = (idUnit, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/${idUnit}/endowments`;

  return async (dispatch) => {
    try {
      dispatch(startRequestComp("loadingRoutesActions"));
      await api_get(url).then((resp) => {
        dispatch({
          type: GET_ENDOWMENT,
          payload: resp,
        });
        action && action();
      });
    } catch (error) {
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp("loadingRoutesActions"));
  };
};

export const editEndowmentMobile = (idUnit, body, type, action = null) => {
  const url = `${
    process.env.REACT_APP_URL
  }${PROYECT}/endowments/units/${idUnit}/${type ? "mobile" : "stationary"}`;

  return async (dispatch) => {
    dispatch(startRequestComp("loadingRoutesActions"));
    try {
      await api_put(url, body);
      dispatch(setSnackbar("Guardado con éxito", "success"));
      action && action();
    } catch (error) {
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp("loadingRoutesActions"));
  };
};

export const editEndowmentStationary = (idUnit, body) => {
  const url = `${PROYECT}/endowments/units/${idUnit}/mobile`;
  return async (dispatch) => {
    await api_put(url, body)
      .then((resp) => {
        dispatch({ type: EDIT_ENDOWMENT, payload: resp });
        dispatch(
          setRoutesSnackbar({
            message: "Guardado con éxito",
            color: "success",
          }),
        );
      })
      .catch((err) => {
        dispatch(
          setRoutesSnackbar({
            message: err,
            color: "danger",
          }),
        );
      });
  };
};

export const assignSGC = (body, form, action = null) => {
  const url = `${
    process.env.REACT_APP_URL
  }${PROYECT}/filling_orders/${body?.sgc || body}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingSGC"));
    try {
      const resp = await api_post(url, form);
      if (!resp?.length) {
        dispatch(setSnackbar("No se generaron órdenes de llenado", "warning"));
        return;
      }
      dispatch({ type: ASSIGN_SGC, payload: resp });
      const { unitNumber, date, folio } = body;
      // Ocultar/mostrar orden de llenado según la configuración de la unidad.
      dispatch(
        printFillingOrderTicket({
          date: formatCustomDate(date, "-"),
          unit: unitNumber,
          unitId: resp[0].idUnit,
          orders: resp,
          download: true,
          action,
          folio,
        }),
      );
      dispatch({
        type: SET_SGC_TO_LIQUIDATION,
        payload: {
          liquidation: resp,
          liquidationId: form.id,
        },
      });
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      dispatch(stopRequestComp("loadingSGC"));
    }
  };
};

export const setRoutesSnackbar = (data) => {
  return {
    type: SET_ROUTES_SNACKBAR,
    payload: data,
  };
};

export const resetRoutesSnackbar = () => {
  return {
    type: RESET_ROUTES_SNACKBAR,
  };
};

export const handleNotesModal = () => {
  return { type: SET_NOTES_MODAL };
};

export const cleanURLTicket = () => {
  return async (dispatch) => {
    dispatch({ type: SET_TICKET_TO_PRINT, payload: "" });
  };
};

export const handleRoutesInputs = (field, data) => {
  const newPayload = {
    [field]: data,
  };

  return {
    type: SET_ROUTES_INPUTS,
    payload: newPayload,
  };
};

//MANUAL_SETTLEMENT LOGIC
export const getSettlementAccountDetails = (date = "", account = {}) => {
  const paramsString = `?date=${formatCustomDate(date, "-")}&account=${
    account?.id
  }`;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/manual/detail-by-date-and-account${paramsString}`;
  return async (dispatch) => {
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: GET_SETTLEMENT_ACCOUNT_DETAILS,
          payload: { ...resp, ...account, date },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SETTLEMENT_ACCOUNT_DETAILS,
          payload: { ...account, date },
        });
        dispatch(
          setSnackbar(error ? error : "Error contacte al administrador"),
        );
      });
  };
};

export const addNewNote = (id) => {
  return {
    type: SET_SETTLEMENT_NEW_NOTE,
    payload: id,
  };
};

export const createSettlementNewNote = (body, close = null) => {
  return (dispatch) => {
    dispatch({ type: ADD_SETTLEMENT_NEW_NOTE, payload: body });
    dispatch(setSnackbar("Nota creada", "success"));
    close && close();
  };
};

export const editSettlementNewNote = (body, close = null, dispatch) => {
  dispatch(setSnackbar("Nota editada", "success"));
  dispatch({ type: ADD_SETTLEMENT_NEW_NOTE, payload: body });
  close && close();
};

export const editSettlementDispenser = (body) => {
  return { type: CHANGE_SETTLEMENT_DISPENSER, payload: body };
};

export const editSettlementTotalReport = (body) => {
  return { type: SETTLEMENT_TOTAL_REPORT, payload: body };
};

export const editSettlementStartRouteEndowment = (key, value) => {
  return {
    type: CHANGE_SETTLEMENT_START_ROUTE_ENDOWMENTS,
    payload: { key, value },
  };
};

export const editSettlementEndRouteEndowment = (key, value, isBulk = false) => {
  return {
    type: CHANGE_SETTLEMENT_END_ROUTE_ENDOWMENTS,
    payload: { key, value, isBulk },
  };
};
export const editSettlementLTS = (key, value, routeType) => {
  return { type: CHANGE_SETTLEMENT_LTS, payload: { key, value, routeType } };
};
export const editSettlementPercentage = (key, value, routeType) => {
  return {
    type: CHANGE_SETTLEMENT_PERCENTAGE,
    payload: { key, value, routeType },
  };
};

export const setKgBulkValue = (val) => {
  return { type: SET_KG_BULK_VALUE, payload: val };
};
export const addNewNoteDetail = (idNote, detail) => {
  return {
    type: SET_SETTLEMENT_NEW_NOTE_DETAIL,
    payload: { idNote, detail },
  };
};

export const selectNoteDetail = (idNote, idDetail) => {
  return {
    type: SELECT_SETTLEMENT_NEW_NOTE_DETAIL,
    payload: { idNote, idDetail },
  };
};

export const editNewNoteDetail = (idNote, idDetail, body) => {
  return {
    type: EDIT_SETTLEMENT_NEW_NOTE_DETAIL,
    payload: { idNote, idDetail, body },
  };
};

export const deleteNewNoteDetail = (idNote, idDetail) => {
  return {
    type: DELETE_SETTLEMENT_NEW_NOTE_DETAIL,
    payload: { idNote, idDetail },
  };
};

export const setUnitPin = (data) => {
  return { type: SET_PIN, payload: data };
};
export const setAutoMode = () => {
  return { type: SET_AUTO_MODE };
};

export const fetchCausesAction = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/deleted_note_causes`;

  return async (dispatch) => {
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: SET_CAUSES,
          payload: resp,
        });
      })
      .catch((error) => {
        dispatch(
          setSnackbar(
            error?.message ? error?.message : "Error contacte al administrador",
          ),
        );
      });
  };
};

export const setDelCause = (noteID, causeID) => {
  return {
    type: SET_DEL_CAUSE,
    payload: { noteID, causeID },
  };
};

export const setNewNote = () => {
  return {
    type: IS_NEW_NOTE,
  };
};

export const removeAllNotes = () => {
  return {
    type: REMOVE_ALL_NOTES,
  };
};

export const removeRouteShare = (route) => {
  return {
    type: REMOVE_ROUTE_SHARE,
    payload: route,
  };
};

export const updateNoteFolio = (noteId, newFolio) => ({
  type: UPDATE_NOTE_FOLIO,
  payload: { noteId, newFolio },
});

/**
 * Clave de loading por ruta para la Carta Porte.
 * Permite que el spinner se muestre únicamente en la fila procesada
 * y no en todas las instancias del botón (loading global compartido).
 */
export const transferInvoiceLoadingKey = (idUnit) =>
  `loadingTransferInvoice_${idUnit}`;

/**
 * Genera la Carta Porte (Factura de Traslado) para una ruta abierta.
 * Endpoint: POST /crm/routes/units/:id_unit/transfer-invoice
 * @param {string} idUnit - ID de la unidad (route)
 * @param {Function} onSuccess - Callback al generar exitosamente
 */
export const generateTransferInvoice = (idUnit, onSuccess = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/routes/units/${idUnit}/transfer-invoice`;
  const loadingKey = transferInvoiceLoadingKey(idUnit);
  return async (dispatch) => {
    dispatch(startRequestComp(loadingKey));
    try {
      const resp = await api_post(url);
      // El backend puede responder 200 con success: false y un mensaje de validación.
      if (resp?.success === false) {
        dispatch(setSnackbar(resp?.message || "Error al generar la Carta Porte", "danger"));
        return;
      }
      // El timbrado regresa el token como pdfToken; el listado de rutas lo expone como transferInvoicePdfToken.
      const token = resp?.pdfToken || resp?.transferInvoicePdfToken || null;
      // Siempre se marca la ruta como generada para bloquear un segundo POST.
      dispatch({ type: SET_TRANSFER_INVOICE_TOKEN, payload: { idUnit, token } });
      if (token) {
        dispatch(setSnackbar("Carta Porte generada correctamente", "success"));
      } else {
        dispatch(setSnackbar("Carta Porte generada. Vuelva a consultar las rutas para descargar el PDF", "warning"));
      }
      onSuccess && onSuccess(resp);
    } catch (error) {
      const message = error?.message || error || "Error al generar la Carta Porte";
      dispatch(setSnackbar(message, "danger"));
    } finally {
      dispatch(stopRequestComp(loadingKey));
    }
  };
};

/**
 * Descarga el PDF de una Carta Porte ya generada.
 * Endpoint: GET /crm/routes/transfer-invoice/pdf?idUnit&pdfToken
 * @param {string} idUnit - ID de la unidad
 * @param {string} pdfToken - Token/path del bucket (transferInvoicePdfToken)
 * @param {Object} fileInfo - Datos para nombrar el archivo ({ unit, startDate })
 */
export const downloadTransferInvoicePdf = (idUnit, pdfToken, { unit, startDate } = {}) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/routes/transfer-invoice/pdf`;
  const loadingKey = transferInvoiceLoadingKey(idUnit);
  return async (dispatch) => {
    dispatch(startRequestComp(loadingKey));
    try {
      const file = await axios({
        url,
        method: "GET",
        params: { idUnit, pdfToken },
        responseType: "blob",
        headers: { authorization: localStorage.getItem("crm-user") },
      });

      const fileName = ["Carta_Porte", unit || idUnit, startDate && formatCustomDate(startDate, "-")]
        .filter(Boolean)
        .join("_");
      saveAs(file.data, `${fileName}.pdf`);
      dispatch(setSnackbar("Carta Porte descargada con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp(loadingKey));
    }
  };
};
